import React, { Component } from 'react';
import ClickOutside from 'react-click-outside';
import PropTypes from 'prop-types';

import { ProjectSidebarView, ProjectMassSidebarView } from 'components/sidebars/project/ProjectSidebarView';
import * as sidebarTypes from 'constants/sidebarTypes';

import PersonSidebarView from 'components/sidebars/person/PersonSidebarView';
import RequestSidebarView from 'components/sidebars/request/RequestSidebarView';
import ApprovalPersonSidebarView from 'components/sidebars/approvals/person/ApprovalPersonSidebarView';
import ApprovalProjectSidebarView from 'components/sidebars/approvals/project/ApprovalProjectSidebarView';
import ActionVacancySidebarView from 'components/sidebars/education/actionVacancy/ActionVacancySidebarView';
import ApplicationSidebarView from 'components/sidebars/education/application/ApplicationSidebarView';
import ActionSidebarView from 'components/sidebars/education/action/ActionSidebarView';
import ApprovalApplicationSidebarView from 'components/sidebars/education/approvalApplication/ApprovalApplicationSidebarView';
import CourseSidebarView from 'components/sidebars/education/course/CourseSidebarView';
import ScenarioSidebarView from 'components/sidebars/education/scenario/ScenarioSidebarView';
import NewsSidebarView from 'components/sidebars/education/news/NewsSidebarView';
import MetroRequestSidebar from 'components/sidebars/metro/MetroRequestSidebar';

export const closestElementWithClass = (className) => (target) => {
    while(target instanceof HTMLElement) {
        if (target.classList.contains(className)) {
            return target;
        }

        target = target.parentNode;
    }
};

const isModalTarget = closestElementWithClass('ant-modal-wrap');
const isSidebarLinkTarget = closestElementWithClass('sidebar-link');
const isNotificationTarget = closestElementWithClass('ant-notification');

const SidebarComponents = {
    [sidebarTypes.PROJECT_SIDEBAR]: ProjectSidebarView,
    [sidebarTypes.PERSON_SIDEBAR]: PersonSidebarView,
    [sidebarTypes.REQUEST_SIDEBAR]: RequestSidebarView,
    [sidebarTypes.APPROVAL_PERSON_SIDEBAR]: ApprovalPersonSidebarView,
    [sidebarTypes.APPROVAL_PROJECT_SIDEBAR]: ApprovalProjectSidebarView,
    [sidebarTypes.ACTION_VACANCY_SIDEBAR]: ActionVacancySidebarView,
    [sidebarTypes.APPLICATION_SIDEBAR]: ApplicationSidebarView,
    [sidebarTypes.ACTION_SIDEBAR]: ActionSidebarView,
	[sidebarTypes.APPROVAL_APPLICATION_SIDEBAR]: ApprovalApplicationSidebarView,
	[sidebarTypes.PROJECT_MASS_SIDEBAR]: ProjectMassSidebarView,
    [sidebarTypes.APPROVAL_APPLICATION_SIDEBAR]: ApprovalApplicationSidebarView,
    [sidebarTypes.COURSE_SIDEBAR]: CourseSidebarView,
    [sidebarTypes.SCENARIO_SIDEBAR]: ScenarioSidebarView,
    [sidebarTypes.NEWS_SIDEBAR]: NewsSidebarView,
    [sidebarTypes.METRO_REQUEST_SIDEBAR]: MetroRequestSidebar
};

@ClickOutside
export default class SidebarSwitcher extends Component {
    static propTypes = {
        sidebarClose: PropTypes.func.isRequired,
        id: PropTypes.number,
        params: PropTypes.object,
        locked: PropTypes.bool,
        componentName: PropTypes.string
    };

    handleClickOutside(event) {
        if (isSidebarLinkTarget(event.target)) return;
        if (isModalTarget(event.target)) return;
        if (isNotificationTarget(event.target)) return;

        const { locked, sidebarClose } = this.props;

        if (!locked) {
            sidebarClose();
        }
    }

    render() {
        const { id, params, componentName } = this.props;
        const SidebarComponent = SidebarComponents[componentName] || null;

        return SidebarComponent && <SidebarComponent id={id} params={params} />;
    }
}
